import { PowerDialerView } from '@/views/power-dialer';
import {
  POWER_DIALER_SUPPORTED_CRMS,
  type PowerDialerSupportedCrm,
} from '@/views/power-dialer/hooks/use-connected-power-dialer-crms';
import { createFileRoute } from '@tanstack/react-router';

type PowerDialerSearch = {
  /**
   * Dev/QA preview: forces the onboarding empty state and seeds the CRM picker
   * with this CRM so the "Connect your CRM" guide can be reviewed without an
   * actual integration connected. e.g. `/power-dialer?previewCrm=hubspot`.
   */
  previewCrm?: PowerDialerSupportedCrm;
};

export const Route = createFileRoute('/_app/power-dialer/')({
  component: PowerDialerView,
  validateSearch: (search: Record<string, unknown>): PowerDialerSearch => {
    const previewCrm = search.previewCrm;
    return typeof previewCrm === 'string' &&
      (POWER_DIALER_SUPPORTED_CRMS as readonly string[]).includes(previewCrm)
      ? { previewCrm: previewCrm as PowerDialerSupportedCrm }
      : {};
  },
});
